import classNames from 'classnames';
import React from 'react';

import './VideoFrame.scss';

export interface VideoFrameProps {
  children: React.ReactElement;
  link: string;
  target?: React.HTMLAttributeAnchorTarget;
  className?: string;
}

export default function VideoFrame({ children, className, link, target = '_blank' }: VideoFrameProps) {
  const classes = classNames(className, 'video-frame');

  return (
    <a href={link} target={target} className={classes}>
      {children}
    </a>
  );
}
